export default "__VITE_ASSET__CuRM085Y__"